/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */
export { HttpTestingController, HttpClientTestingModule, TestRequest } from "./public_api";
export { HttpClientTestingBackend as ɵa } from "./src/backend";
//# sourceMappingURL=testing.js.map